import { Controller } from '@hotwired/stimulus';
import Sortable from 'sortablejs';

export default class extends Controller {
  static values = { handlerClass: String, handlerSpanClass: String }

  connect () {
    this.sortable = Sortable.create(this.element, {
      ghostClass: 'preferences-form-ghost',
      animation: 150,
      handle: '.handle',
      onEnd: this.reorder.bind(this),
    });
  }

  reorder (event) {
    const selects = [].slice.call(event.item.parentElement.children);
    const handlerClass = this.handlerClassValue;
    const handlerSpanClass = this.handlerSpanClassValue;

    selects.forEach((item, index) => {
      item.querySelector(handlerClass).value = index + 1;
      item.querySelector(handlerSpanClass).innerHTML = index + 1;
    });
  }
}
